module.exports = __webpack_public_path__ + "static/img/Pula-Puti.3c4892c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/Pula-Puti.png
// module id = 5a0A
// module chunks = 1